import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';

export const generateTablePDF = async (tableRef) => {
  if (!tableRef.current) {
    console.error('Table element not found');
    return;
  }

  try {
    const pdf = new jsPDF({
      orientation: 'p', // Landscape for better table view
      unit: 'px',
      format: 'a4',
    });

    // Get the full table height
    const tableElement = tableRef.current;
    const canvas = await html2canvas(tableElement, {
      scale: 2,
      useCORS: true,
      logging: false,
      allowTaint: true,
      backgroundColor: '#ffffff',
    });

    const margin = 20;
    const imgData = canvas.toDataURL('image/jpeg', 1);
    const pdfWidth = pdf.internal.pageSize.getWidth() - 2 * margin;
    const pdfHeight = pdf.internal.pageSize.getHeight() - 2 * margin;

    // Calculate image dimensions
    const imgWidth = pdfWidth;
    const imgHeight = (canvas.height * imgWidth) / canvas.width;

    // If table is longer than one page, split into multiple pages
    if (imgHeight > pdfHeight) {
      const totalPages = Math.ceil(imgHeight / pdfHeight);
      
      for (let page = 0; page < totalPages; page++) {
        if (page > 0) {
          pdf.addPage();
        }

        const sourceY = page * pdfHeight;
        pdf.addImage(
          imgData, 
          'JPEG', 
          margin, 
          margin - sourceY, 
          imgWidth, 
          imgHeight
        );
      }
    } else {
      // Single page scenario
      pdf.addImage(imgData, 'JPEG', margin, margin, imgWidth, imgHeight);
    }

    pdf.save(`Report-${new Date().toISOString().split('T')[0]}.pdf`);
  } catch (error) {
    console.error('PDF generation error:', error);
  }
};

// Usage in a component
export const useTablePDFDownload = (tableRef) => {
  const handleDownloadTablePDF = () => {
    generateTablePDF(tableRef);
  };

  return handleDownloadTablePDF;
};